import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PalantirButtonComponent } from '../button/button.component';
import { PalantirContentComponent } from '../content/content.component';
import { PalantirIconComponent } from '../icon/icon.component';
import { PalantirTextComponent } from '../text/text.component';
import { PalantirDropdownMenuComponent } from './dropdown-menu.component';
import { DropdownItemDirective } from './dropdown-menu.directive';

@NgModule({
  imports: [
    CommonModule,
    PalantirButtonComponent,
    PalantirIconComponent,
    PalantirTextComponent,
    PalantirContentComponent,
    CdkMenuModule,
  ],
  declarations: [DropdownItemDirective, PalantirDropdownMenuComponent],
  exports: [DropdownItemDirective, PalantirDropdownMenuComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PalantirDropdownMenuModule {}
